export default '//ms.jr.jd.com/'
